import { jsxs, jsx } from "react/jsx-runtime";
const IconCubeSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M13.647 4.913V4.86l-.04-.1a.485.485 0 0 0-.047-.06.624.624 0 0 0-.06-.08l-.06-.047-.107-.053-5-3.087a.667.667 0 0 0-.706 0L2.667 4.52l-.06.053-.06.047a.627.627 0 0 0-.06.08.474.474 0 0 0-.047.06l-.04.1v.053a.767.767 0 0 0 0 .174v5.826a.667.667 0 0 0 .313.567l5 3.087a.333.333 0 0 0 .1.04h.054a.573.573 0 0 0 .346 0h.054a.312.312 0 0 0 .1-.04l4.966-3.087a.667.667 0 0 0 .314-.567V5.087a.773.773 0 0 0 0-.174Zm-6.314 7.894L3.667 10.54V6.287l3.666 2.26v4.26ZM8 7.393 4.267 5.087 8 2.787l3.733 2.3L8 7.393Zm4.333 3.147-3.666 2.267v-4.26l3.666-2.26v4.253Z" })
    ]
  }
);
export {
  IconCubeSvg
};
